import { Component, OnDestroy } from '@angular/core';
import { BaseModalService } from '@ems-gui/expense/util-web-infrastructure';
import {
  ActivityActions,
  LayoutActions,
  NewActions,
  WebDashboardFacade,
  WebSubmitterFacade,
  selectedProxyId,
  AllModalActions,
  State,
  selectUserHasCreditCard
} from "@ems-gui/expense/util-web-ngrx";
import { SORT_ORDER } from '@ems-gui/shared/util-core';
import { ToastrService } from 'ngx-toastr';
import { firstValueFrom, Observable, Subject } from "rxjs";
import { select, Store } from '@ngrx/store';

@Component({
  selector: 'ems-dashboard-page',
  templateUrl: './dashboard-page.component.html',
  styleUrls: ['./dashboard-page.component.scss'],
})
export class DashboardPageComponent implements OnDestroy {
  private unsubscribe$ = new Subject<void>();
  page = null;
  sortOrder = SORT_ORDER;
  proxy$: Observable<any>;
  ccUser$ = this.store$.select(selectUserHasCreditCard);

  constructor(
    public modalService: BaseModalService,
    public dashboardState: WebDashboardFacade,
    public submitterState: WebSubmitterFacade,
    private toastrService: ToastrService,
    private store$: Store<State>,
  ) {
    this.proxy$ = this.store$.select(selectedProxyId);
  }

  public async onOpenModal(data) {
    const isNewExpenseModal = [
      'expense-new-modal',
      'file-upload'
    ].includes(data.name);
    if(
      isNewExpenseModal && await firstValueFrom(this.ccUser$)
    ) {
      data = {
        name: 'credit-card-holder-alert',
        continueTo: data.name
      };
    }
    const { name, continueTo, id } = data;

    if (continueTo) {
      this.dashboardState.dispatch(AllModalActions.setContinueTo({ continueTo }));
    }

    if (id) {
      this.dashboardState.dispatch(
        ActivityActions.getSubmittedActivity({ id })
      );
    }


    this.dashboardState.dispatch(LayoutActions.openExpenseModal({ name, id }));
  }

  onUpload(image) {
    this.submitterState.dispatch(NewActions.upload({ image }));
  }

  onReceiptUploaded(id) {
    this.dashboardState.dispatch(NewActions.getExpenseData({ token: id }));
  }

  onReceiptUploadSizeError(error) {
    this.dashboardState.dispatch(NewActions.uploadError({ error }));
    this.toastrService.show('Receipt file size cannot exceed 6MB.', '', {
      timeOut: 10000,
    });
  }

  ngOnDestroy() {
    this.toastrService.clear();
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
